import { ServiceTypes } from 'constants/ServiceTypes';
import { IVideoUploadProvider } from 'interfaces/providers/IVideoUploadProvider';
import { IVideoAvailability } from 'interfaces/tagging/ApiModels/IVideoAvailability';
import { useEffect, useState } from 'react';
import { FeatureConfigService } from 'services/FeatureConfigService';
import { useInjection } from 'services/ioc/ioc.react';
import { LineupStore } from 'stores/LineupStore';

interface VideoUploaderHook {
  videoAvailability: IVideoAvailability | undefined;
  isVideoCaptureEnabled: boolean;
  videoAvailabilityLoading: boolean;
  handleVideoCaptureEnabled: (checked: boolean) => void;
}

export function useVideoUploader(): VideoUploaderHook {
  const featureConfigService = useInjection<FeatureConfigService>(ServiceTypes.FeatureConfigService);
  const [videoAvailability, setVideoAvailability] = useState<IVideoAvailability>();
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);
  const [isVideoCaptureEnabled, setIsVideoCaptureEnabled] = useState<boolean>(lineupStore.isVideoCaptureEnabled);
  const videoUploadService = useInjection<IVideoUploadProvider>(ServiceTypes.VideoUploadService);
  const [videoAvailabilityLoading, setVideoAvailabilityLoading] = useState<boolean>(true);

  const handleVideoCaptureEnabled = (enabled: boolean): void => {
    setIsVideoCaptureEnabled(enabled);
    lineupStore.setIsVideoCaptureEnabled(enabled);
  };

  useEffect(() => {
    if (featureConfigService.getConfig().isUploadVideoEnabled) {
      setVideoAvailabilityLoading(true);
      videoUploadService
        .getAvailability()
        .then((value: IVideoAvailability) => setVideoAvailability(value))
        .finally(() => setVideoAvailabilityLoading(false));
    } else {
      handleVideoCaptureEnabled(false);
    }
  }, [videoUploadService]);

  return { videoAvailability, isVideoCaptureEnabled, videoAvailabilityLoading, handleVideoCaptureEnabled };
}
